// extracted by mini-css-extract-plugin
export default {"mainWrap":"Cabinet_mainWrap__guu+r"};